// Renforts éligibles (D-133) : les textes de « Convoquer un renfort ». La règle elle-même est en base
// (renfort_candidates) : sa catégorie, une U20 en Seniors, jamais en dessous, au-dessus avec un surclassement en vigueur
// (un double couvre la catégorie du milieu) ; équipe mixte : tout le monde, sinon le sexe de l'équipe.
import { categoriesAbove } from './categories';
import type { TeamGender } from './labels';

export type RenfortStatus = 'ok' | 'pending' | 'verify';
export type VerifyReason = 'categorie' | 'sexe' | 'categorie_sexe';

const NEXT: Record<string, string> = { U7: 'U9', U9: 'U11', U11: 'U13', U13: 'U15', U15: 'U17', U17: 'U20', U18: 'U20' };
const upgraded = (g: TeamGender) => (g === 'F' ? 'les filles surclassées' : g === 'M' ? 'les garçons surclassés' : 'les surclassés');
const teamWord = (g: TeamGender) => (g === 'F' ? ' filles' : g === 'M' ? ' garçons' : '');

/** « Peuvent jouer : les U13 filles, et les filles surclassées U13 (simple ou double). » */
export function renfortHint(cat: string | null | undefined, g: TeamGender): string {
  if (!cat) return 'Peuvent jouer : tout le club (la catégorie de l’équipe n’est pas renseignée).';
  const u20 = cat === 'Seniors' ? ', les U20' : '';
  return `Peuvent jouer : les ${cat}${teamWord(g)}${u20}, et ${upgraded(g)} ${cat} (simple ou double).`;
}

/** « Pas proposées : les U15 et plus (on ne joue pas en dessous de sa catégorie), les garçons (équipe filles), les non surclassées. » */
export function renfortNotOffered(cat: string | null | undefined, g: TeamGender): string {
  if (!cat) return '';
  // La première catégorie d'un échelon au-dessus (U17 et U18 sont du même échelon ; une U20 joue en Seniors).
  const next = NEXT[cat] ?? categoriesAbove(cat)[0];
  const parts: string[] = [];
  if (next && cat !== 'Seniors' && cat !== 'U20') parts.push(`les ${next} et plus (on ne joue pas en dessous de sa catégorie)`);
  if (g === 'F') parts.push('les garçons (équipe filles)');
  if (g === 'M') parts.push('les filles (équipe garçons)');
  parts.push(g === 'F' ? 'les non surclassées' : 'les non surclassés');
  return `Pas ${g === 'F' ? 'proposées' : 'proposés'} : ${parts.join(', ')}.`;
}

/** Ce qui manque à la fiche pour la proposer. */
export function verifyText(reason: VerifyReason | null | undefined): string {
  if (reason === 'sexe') return 'Sa fiche n’indique pas le sexe : à compléter dans l’effectif pour la proposer.';
  if (reason === 'categorie') return 'Ni date de naissance ni équipe : à compléter dans l’effectif pour la proposer.';
  return 'Ni date de naissance ni sexe sur sa fiche : à compléter dans l’effectif pour la proposer.';
}

/** Le titre replié « À vérifier » : ce qui manque le plus souvent. */
export function verifyLabel(reasons: (VerifyReason | null | undefined)[]): string {
  const sex = reasons.some(r => r === 'sexe' || r === 'categorie_sexe'), cat = reasons.some(r => r === 'categorie' || r === 'categorie_sexe');
  return sex && cat ? 'fiche à compléter' : sex ? 'sexe à renseigner' : 'date de naissance à renseigner';
}
